import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Link, useParams, generatePath } from "react-router-dom";
import Footer from "./Footer";
import BottomBarIcons from "./BottomBarIcons";
import Header from "./Header";
import Sidebar from "./Sidebar";
import {
  dummyClientTile,
  dummyRecentActivities,
  // Paths,
} from "./common/constant";
import { GET_PROPERTIES_CLIENT } from "../api/apiPath";
import http from "../api/server";
import SidebarIcons from "./SidebarIcons";

const ClientDashboard = () => {
  const [hideSidebar, setHideSidebar] = useState(true);
  const { clientNameParam } = useParams();
  const { userObj } = useSelector((state) => state.user);
  const [tileData, setTileData] = useState([]);
  const [recentActivities, setRecentActivities] = useState([]);
  const navigate = useNavigate();

  const [error, setError] = useState(null);
  const clientId = "b7871dc2-c696-4736-8ffa-432b325828ac"; // Replace with actual client ID if needed

  useEffect(() => {
    if (userObj) {
      setTileData(dummyClientTile);
      setRecentActivities(dummyRecentActivities);
      const fetchData = async () => {
        await fetchPropertyData();
      };
      fetchData();
    }
  }, [userObj]);

  // const gotoPath = (path) => {
  //   navigate(path);
  // };
  const fetchPropertyData = async () => {
    try {
      const response = await http.get(
        GET_PROPERTIES_CLIENT + `?clientId=${clientId}`
      );

      if (!response.status) {
        throw new Error("Failed to fetch property data");
      }

      const data = await response?.data;
      console.log("Property data fetched successfully:", data);
    } catch (error) {
      console.error("Error fetching property data:", error);
      setError(error);
    }
  };

  if (error)
    return (
      <>
        <div className="inCenterDiv">
          <i className="bi bi-exclamation-triangle red"></i>
          <h3>Something went wrong!</h3>
          <p>{error?.message}</p>
          <div className="col-sm-12 mb-4 text-center">
            <Link to={generatePath("/client/:clientNameParam/", {
                                        clientNameParam,
                                      })}>Go back to Login</Link>
          </div>
        </div>
      </>
    );
  return (
    <>
      <div>
        <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      </div>
      {userObj && (
        <div className="dashboard_body_main d-flex vh-100">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons />
          )}

          <div className="d-flex dashboard_body flex-column py-3 w-100">
            <div className="row m-3">
              <div className="col-12 col-sm-4 col-lg-4 mb-3 ps-0">
                <div className="card build-credit-card ">
                  <div className="card-body bulid_card_main  text-center d-flex flex-column gap-2 py-4">
                    <div className="d-flex justify-content-between">
                      <div className="pound">
                        <h2>$</h2>
                      </div>
                      <div className="pound">
                        <h3>1240pts</h3>
                        <span>survey point</span>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center">
                      <a href="" onClick={() => navigate(
                        generatePath("/client/:clientNameParam/subscription", {
                        clientNameParam,
                      })
                      )}>
                        Add points
                      </a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span>{userObj?.userName}</span>
                      <span>****231</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-8 col-lg-8 mb-3 ">
                <div className="card bulid_card border-0 h-100">
                  <div className="card-body border-none d-flex flex-column gap-2 align-items-start">
                    <h4>Recent Activities</h4>
                    <ul>
                      {recentActivities &&
                        recentActivities.map((item, index) => {
                          return (
                            <li style={{ textAlign: "justify" }} key={index}>
                              {item}
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="row m-3">
              <div className="card bulid_card border-0">
                <div className="row my-4 ">
                  <div className="d-flex col-12 col-sm-10 col-lg-8 mb-3 ps-3">
                    {" "}
                    <h5>Summary</h5>
                  </div>

                  <div className="d-flex col-12 col-sm-2 col-lg-4 mb-3 ps-0 gap-3 text-end gap-3 justify-content-end">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => {
                        navigate(
                          generatePath("/client/:clientNameParam/inviteNewMember", {
                          clientNameParam,
                        })
                        );
                      }}
                    >
                      Invite User
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        navigate(
                          generatePath("/client/:clientNameParam/addProperty", {
                                  clientNameParam,
                                })
                        );
                      }}
                    >
                      Add New Property
                    </button>
                  </div>
                </div>
                <div className="row m-0">
                  {tileData &&
                    tileData.map((item) => {
                      return (
                        <div
                          key={item.tileId}
                          className="col-6 col-sm-6 col-lg-3 mb-3"
                        >
                          <div className="card bulid_card border-0 ">
                            <div className="card-body text-center d-flex flex-column gap-2">
                              <small>{item.tileName}</small>
                              <h3>{item.tileValue}</h3>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>

            <Footer />
<div className="bottom-bar-spacing"></div>
<BottomBarIcons />
           
          </div>
        </div>
      )}
    </>
  );
};

export default ClientDashboard;
